import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ThemeService } from "./core/services/theme.service";
import { SmartchatService } from "./core/services/smartchat.service";
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
    selector: "app-root",
    standalone: true,
    imports: [
        RouterOutlet,
        HttpClientModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatIconModule,
        MatCheckboxModule,
    ],
    templateUrl: "./app.html",
    styleUrls: ["./app.scss"],
})
export class AppComponent {
    title = "sten-score-ui";
    private readonly themeService = inject(ThemeService);
    private readonly smartchatService = inject(SmartchatService);
}
